export class Discount {
    description: string;
    amount: number;
    type?: string;
}
